var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"design-button",class:{
    fullWidth: _vm.fullWidth,
    primary: _vm.color === 'primary',
    green: _vm.color === 'green',
    'x-small': _vm.size === 'x-small',
    'x-large': _vm.size === 'x-large',
    dimmed: _vm.disabled
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"design-button-content"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }